export const language: any = {
  LabelCarts: "စျေးခြင်း",
  Material: "ပစ္စည်း",
  nodata: "စျေးခြင်းတွင် အချက်အလက်မရှိပါ",
};
